import { ICreateEntregaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/create/create_entrega_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateEntregaPesquisaSatisfacaoUseCase
 */

export class CreateEntregaPesquisaSatisfacaoUseCase implements ICreateEntregaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObraCliente: number,
    idPesquisaSatisfacao: number,
  ): Promise<void> {

    await this.repository.createEntregaPesquisaSatisfacao(
      idEntregaObraCliente,
      idPesquisaSatisfacao,
    );

  }

}
